import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

const Select = loadable(() => import('react-select'), { ssr: false });

const DSSelect = ({ options, renderHeader = null, renderIcon = null, itemLabel = 'label', itemValue = 'value', ...props }) => {
    const _options = options.map((item) => ({
        value: item[itemValue],
        label: item[itemLabel],
    }));

    return (
        <>
            {renderHeader}
            {renderIcon ? (
                <div className="align-items-center">
                    {renderIcon}
                    <Select {...props} options={_options} />
                </div>
            ) : (
                <Select {...props} options={_options} />
            )}
        </>
    );
};

DSSelect.propTypes = {
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
    renderHeader: PropTypes.node,
    renderIcon: PropTypes.node,
    itemValue: PropTypes.string,
    itemLabel: PropTypes.string,
};

export default DSSelect;
